export const DELETE_PRODUCT_SUBSCRIPTION_MODAL_NAME =
  'DELETE_PRODUCT_SUBSCRIPTION_MODAL_NAME';
